var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.37255 18.0018C4.13059 18.0018 4.7451 17.4178 4.7451 16.6974C4.7451 15.977 4.13059 15.3931 3.37255 15.3931C2.61451 15.3931 2 15.977 2 16.6974C2 17.4178 2.61451 18.0018 3.37255 18.0018Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5816 11.8695C10.3035 11.8695 10.8888 11.2563 10.8888 10.4999C10.8888 9.74354 10.3035 9.13037 9.5816 9.13037C8.85966 9.13037 8.27441 9.74354 8.27441 10.4999C8.27441 11.2563 8.85966 11.8695 9.5816 11.8695Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6997 15.9134C14.4577 15.9134 15.0722 15.3294 15.0722 14.609C15.0722 13.8887 14.4577 13.3047 13.6997 13.3047C12.9417 13.3047 12.3271 13.8887 12.3271 14.609C12.3271 15.3294 12.9417 15.9134 13.6997 15.9134Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6274 8.73912C21.3855 8.73912 22 8.12595 22 7.36956C22 6.61317 21.3855 6 20.6274 6C19.8694 6 19.2549 6.61317 19.2549 7.36956C19.2549 8.12595 19.8694 8.73912 20.6274 8.73912Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.0918 15.9113L8.53624 11.6069",
    stroke: "current",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4971 11.3491L12.85 13.6969",
    stroke: "current",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.418 13.9578L20.0389 8.34912",
    stroke: "current",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDashboard);
export default __webpack_public_path__ + "static/media/ic_dashboard.3391ae0890e53bd984d1979e15d9806b.svg";
export { ForwardRef as ReactComponent };